/**
 * Done. / ChiroCPD — AILabel Primitive
 *
 * "◆ AI-generated draft" badge. NEVER dismissible.
 * Present on ALL AI output — non-negotiable per contract.
 *
 * Pure render — no props, no state.
 */

export function AILabel(): React.ReactElement {
  return (
    <span
      className="inline-flex items-center gap-1 text-xs text-[var(--text-muted)] font-medium"
      aria-label="This content is an AI-generated draft. Review before submitting to the Board portal."
    >
      <span aria-hidden="true">◆</span>
      <span>AI-generated draft</span>
    </span>
  );
}
